import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import NewPartnerForm from 'components/Admin/Partner/NewPartnerForm';
import actions from 'actions';
import constants from 'constants';
import validator from 'services/validator';
import inputFormatter from 'services/userInputFormatter';

const {
  CREATE_PARTNER_SAGA
} = constants;

const {
  createPartnerSaga,
  cleanErrors
} = actions;

class NewPartner extends Component {
  static propTypes = {
    createPartner: PropTypes.func,
    cleanErrors: PropTypes.func,
    dispatch: PropTypes.func,
    errors: PropTypes.obj,
    errorsFrontend: PropTypes.obj
  };

  constructor(props) {
    super(props);
    this.state = {
      partner: {
        title: '',
        logo: '',
        namespace: ''
      }
    }
  }

  componentWillMount() {
    this.props.cleanErrors();
  }

  onFieldChange = (e) => {
    const input = inputFormatter.formatField(e.target.name, e.target.value);
    const partnerData = {
      ...this.state.partner,
      ...{
        [e.target.name]: input
      }
    }

    this.setState({ partner: partnerData });
  }

  onSubmit = () => {
    this.props.createPartner(this.state.partner)
  }

  render() {
    const {
      errors,
      errorsFrontend
    } = this.props;
    return (
      <main className="site--width clearfix-c">
        <NewPartnerForm
          onFieldChange={this.onFieldChange}
          partner={this.state.partner}
          onSubmit={this.onSubmit}
          errors={validator.formatErrors(errors, errorsFrontend)}
        />
      </main>
    );
  }
}

function mapStateToProps(state) {
  return {
    errors: state.errors[CREATE_PARTNER_SAGA],
    errorsFrontend: state.errors[`${CREATE_PARTNER_SAGA}_FRONTEND`]
  };
}

function mapDispatchToProps(dispatch) {
  return {
    createPartner: (partner) => dispatch(createPartnerSaga(partner)),
    cleanErrors: () => dispatch(cleanErrors(CREATE_PARTNER_SAGA)),
    dispatch: dispatch
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(NewPartner);



// WEBPACK FOOTER //
// ./src/containers/Admin/Partner/NewPartner.jsx